import type { ClaimReviewStepData } from '@/types';

const claimReviewStepData: ClaimReviewStepData = {
  id: 'claim-review-step-section',
  testId: 'claim-review-step-section',
  title: 'Review and submit your claim',
  description:
    "You're almost done. Please take a few minutes to review all these details before you submit your claim.",
  policyDetails: {
    title: 'Your policy details',
    labels: {
      policyNumber: 'Policy number',
      excess: 'Excess',
      planName: 'Plan',
      travelDates: 'Travel dates',
      destinations: 'Destination(s)',
      policyStartDate: 'Policy start date',
      maxTripDuration: 'Maximum trip duration',
    },
  },
  medicalExpense: {
    labels: {
      expenseType: 'Expense type',
      expenseDate: 'Expense date',
      expenseAmount: 'Expense amount',
      expensePaidInFull: 'Expense paid in full',
      accountName: 'Account name',
      swiftCode: 'SWIFT code',
      ibanNumber: 'IBAN number',
      referenceNumber: 'Invoice or order number',
      providerOwedAmount: 'Amount owed to provider',
      claimAmount: 'Claim amount',
    },
  },
  cancellationExpense: {
    labels: {
      expenseType: 'Expense type',
      expenseDescription: 'Expense description',
      expenseDate: 'Expense date',
      expenseAmount: 'Expense amount',
      creditNoteOrRefundReceived: 'Received refund or credit note',
      creditNoteOrRefundAmount: 'Refund or credit note amount',
      claimAmount: 'Claim amount',
    },
  },
  additionalExpense: {
    labels: {
      expenseType: 'Expense type',
      expenseDescription: 'Expense description',
      expenseDate: 'Expense date',
      expenseAmount: 'Expense amount',
      creditNoteOrRefundReceived: 'Received refund or credit note',
      creditNoteOrRefundAmount: 'Refund or credit note amount',
      claimAmount: 'Claim amount',
    },
  },
  declaration: {
    title: 'Declaration',
    checkboxLabel: (
      <>
        <p>
          <strong>
            I declare that: <span aria-hidden="true"> *</span>
          </strong>
        </p>
        <ul>
          <li>
            The information provided in this claim is true and accurate and all available
            information that is likely to affect this claim has been included and no information has
            been withheld. I understand Cover-More Travel Insurance may refuse this claim, cancel my
            policy or both, if the information and declarations provided in this claim are not
            truthful and accurate.
          </li>
          <li>I am the person making this claim.</li>
          <li>
            I have read and understand the{' '}
            <a
              href="https://www.covermore.com.au/CoverMore_Privacy_Notice"
              target="_blank"
              rel="noopener noreferrer">
              Privacy Notice
            </a>{' '}
            and consent to the collection and use of my sensitive information, if any.
          </li>
          <li>
            You may send the personal information included in this claim and related documents,
            overseas to assess, investigate and pay my claim. I understand that this data may not be
            subject to the same level of Privacy as is offered by the Australian Privacy Regime and
            that I will not be able to seek redress under the Australian Privacy Act 1988 and
            redress may not be possible in the overseas jurisdiction.
          </li>
          <li>
            Where I provide information, including sensitive information, about other individuals,
            that I have informed them (or their parent guardian, executor or Power of Attorney) of
            the personal information being provided and of the contents of this privacy notice and
            have obtained their consent to providing the information.
          </li>
        </ul>
      </>
    ),
    alert: {
      title: 'Important:',
      description: (
        <ul>
          <li>
            If applicable, and you would like your travel consultant to be able to provide and
            receive information, including sensitive information, relating to this claim please
            contact Cover-More to provide your consent.
          </li>
          <li>
            <span>
              A copy of the Cover-More privacy policy is available on our website{' '}
              <a
                href="https://www.covermore.com.au/covermore-privacy-policy"
                target="_blank"
                rel="noopener noreferrer">
                Privacy Policy | Cover-More Australia
              </a>
              .
            </span>
          </li>
        </ul>
      ),
    },
  },
  docUploads: {
    title: 'Upload your supporting evidence',
  },
};

export default claimReviewStepData;
